import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

export const AzerpoctService = {
  async getAzerpoctRegions() {
    let response = await $axios
      .get($api("get_azerpoctRegions"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getPostIndexByRegion(regionId: string) {
    let response = await $axios
      .get($api("get_regionByIndex", { regionId }), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : null,
      status: response?.status,
    };
  },
  async getAzerpoctOrder() {
    let response = await $axios
      .get($api("package"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async PostAzerpoctOrder(payload: any) {
    try {
      const response = await $axios.post($api("post_AzerpoctOrders"), payload);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
  //   async getAzerpoctOrders() {
  //     let response = await $axios
  //       .get($api("get_AzerpostOrder"), {
  //         headers: {
  //           "Accept-Language": "az",
  //           Authorization: `Bearer ${getCookie("ColibriToken")}`,
  //         },
  //       })
  //       .catch((err) => {
  //         return err.response;
  //       });
  //     return {
  //       data: response?.data ? response?.data : [],
  //       status: response?.status,
  //     };
  //   },

  async getAzerpoctOrders(url?: string) {
    let response = await $axios
      .get(url || $api("get_AzerpostOrder"), {
        headers: {
          "Accept-Language": "az",
          Authorization: `Bearer ${getCookie("ColibriToken")}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async Post_calculatedelivery_Azerpost(payload: any) {
    try {
      const response = await $axios.post(
        $api("post_azerpoct_delivery"),
        payload
      );
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};
